import { Helmet } from 'react-helmet-async';
import { CodesSettings } from 'src/components/settings/CodesSettings';

export default function SettingsPage() {
  return (
    <>
      <Helmet>
        <title> Settings </title>
      </Helmet>
      <CodesSettings />
    </>
  );
}
